module.exports = __webpack_public_path__ + "static/media/Guardar.4138c6e8.svg";